import React from 'react';
import { FaFacebookF, FaTiktok } from 'react-icons/fa';

export default function Footer() {
    return (
        <footer className="bg-white border-t border-gray-200 mt-auto">
            <div className="max-w-7xl mx-auto px-6 py-10">
                <div className="flex flex-col items-center text-center">
                    {/* Tiêu đề Liên hệ */}
                    <p className="text-lg font-semibold text-gray-800 mb-6">
                        Liên hệ
                    </p>

                    {/* Social Links */}
                    <div className="flex flex-col sm:flex-row gap-6 mb-8">
                        {/* TikTok */}
                        <a 
                            href="https://www.tiktok.com/@mynghebongiu" 
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 text-gray-700 hover:text-black transition-all group"
                        >
                            <div className="text-2xl group-hover:scale-110 transition-transform">
                                <FaTiktok />
                            </div>
                            <span className="text-sm">@mynghebongiu</span>
                        </a>

                        {/* Facebook */}
                        <a 
                            href="https://www.facebook.com/bongiudamynghecaocap" 
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 text-gray-700 hover:text-black transition-all group"
                        >
                            <div className="text-2xl group-hover:scale-110 transition-transform">
                                <FaFacebookF />
                            </div>
                            <span className="text-sm">bongiudamynghecaocap</span>
                        </a>
                    </div>

                    {/* Divider */}
                    <div className="w-16 h-px bg-gray-300 mb-6"></div>

                    {/* Bottom Links */}
                    <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-sm text-gray-500">
                        <a href="/dieu-khoan" className="hover:text-gray-800 transition-colors">
                            Điều khoản
                        </a>
                        <a href="/bao-mat" className="hover:text-gray-800 transition-colors">
                            Chính sách bảo mật
                        </a>
                        <a href="/lien-he" className="hover:text-gray-800 transition-colors">
                            Liên hệ
                        </a>
                    </div>

                    {/* Copyright */}
                    <p className="text-xs text-gray-400 mt-8">
                        © {new Date().getFullYear()} Bông iu. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}